import ReportsHistory from '../components/reports/ReportsHistory'
import ReportForm from '../components/reports/ReportForm'
import { createApp } from 'vue';

if (document.getElementById('report-form-container')) {
    const app = createApp({
        components: {
            ReportForm,
            ReportsHistory
        },
        methods: {
            scrollToHistory() {
                window.scroll({
                    top: this.$refs.history.$el.offsetTop,
                    behavior: 'smooth'
                })
            }
        }
    });

    app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app.mount('#report-form-container');
}